import { ALERT_HIDE, ALERT_SHOW } from "../actions/alert";
import { PAGE_TRANSITIONING } from "../actions/session";
import buildReducer from "./build-reducer";
import { Map } from "immutable";

let reducers = {};

reducers[PAGE_TRANSITIONING] = (state) =>
  state.clear();

reducers[ALERT_HIDE] = (state) =>
  state.clear();

reducers[ALERT_SHOW] = (state, { alertType: type, icon, title, text }) =>
  state.merge({ type, icon, title, text });

export default buildReducer(Map(), reducers);
